import React, { Component } from 'react';
import styles from '../../styles/login.module.css';
import LoginForm from './LoginForm';
import ForgotPassword from '../password/ForgotPassword';
import ForgotUserName from '@components/password/ForgotUserName';
import FirstSetup from '../password/FirstSetup';
import LoginStep2 from './LoginStep2';
import LoginChangePassword from '../login/LoginChangePassword';
import { connectApp } from '../../actions/login';
import { generateToken } from '../../actions/authentication';
import Alert from 'react-bootstrap/Alert';
import * as LoginCode from '../../scripts/StatusLoginCode';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import InstallPWA from '../PWA/InstallPWA';
import InstallPWAIOS from '../PWA/InstallPWAIOS';
import * as storage from '../../utils/storage';
import * as cookie from '../../scripts/CookiesAppGo';
import i18n from '../../i18n/i18n';
import AlertAlgo from '../controls/AlertSnack';
import { loadLocalization } from '../../utils/kendoLocalization';
import HelpOnlineButton from '../helpOnline/HelpOnlineButton';
import * as SourcePage from '../../scripts/HelpOnlineSourcePage';
import logo from "../../images/KoneK_logo_2.jpg";
import { log } from '../../actions/error'
import { isIOS } from '../../utils';
import { sessionLogout } from '../../actions/login';
import { IsEmployeeMode, IsSupervisorMode } from '@users';
import { AppContext } from '@/AppContext';

loadLocalization();

class Login extends Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            errorSSO: false,
            errorGeneral: false,
            errorSession: false,
            errorMenu: false,
            errorParam: false,
            errorLogin: false,
            openFirstSetup: false,
            openLoginStep2: false,
            openLoginChangePassword: false,
            listStep2: [],
            language: 'fr',
            userCode: '',
            version: '',
            isiOS: isIOS(),
            applyAnimation: false,
            showForgotPassword: false,
            showForgotUserName: false,
            isMultiCompany: false,
            defaultCompany: '',
            isActivatePrefix: false,
            listPrefixConnection: [],
            companyTitle: '',
            buidNumber: 0
        };
        this.alert = React.createRef();
    }

    // Key line: make the context available as this.context
    static contextType = AppContext;

    componentDidMount() {
        this.loadPage();
    }

    loadPage = async () => {
        await storage.init();

        // Always reset the param � false for security
        storage.saveIsSSO(false);

        //Caching();
        // On loading the login page we always clean the session by security
        sessionLogout();
        this.logDeviceInfo();
        this.getVersion();
        this.validateLanguage();
        this.resetSession();
        this.validateError();

        this.setState({ companyTitle: storage.getConfigCompanyTitle() });

        setTimeout(() => {
            this.setState({ applyAnimation: true });
        }, 1500);
    }

    logDeviceInfo = () => {
        if (storage.getConfigLogInfoDevice()) {
            const platform = window.navigator.platform;// system operation
            const isMobile = window.navigator.userAgentData.mobile; // check if is mobile device
            const mobSystem = window.navigator.userAgentData.platform; // mob system operation
            const mobVersion = navigator.appVersion; // device version
            const info = `Platform = ${platform} / IsMobile = ${isMobile} / MobSystem = ${mobSystem} / MobVersion = ${mobVersion}`;

            log(info);
        }
    }

    getVersion = () => {
        fetch("./meta.json?v=" + new Date().getMilliseconds())
            .then(response => {
                return response.json();
            })
            .then(meta => {
                const version = meta.version;
                const buildNumber = meta.build ?? 0;
                this.setState({ version: version, buildNumber: buildNumber });
            });
    }

    validateError = () => {
        if (this.props.match.params.error === "1") {
            this.setState({ errorSession: true })
        } else if (this.props.match.params.error === "2") {
            this.setState({ errorMenu: true })
        } else if (this.props.match.params.error === "3") {
            this.setState({ errorParam: true })
        } else if (this.props.match.params.error === "4") {
            this.setState({ errorGeneral: true, applyAnimation: true })
        } else if (this.props.match.params.error === "5") {
            this.setState({ errorSSO: true, applyAnimation: true })
        } else if (this.props.match.params.error === "999") {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (let registration of registrations) {
                    registration.unregister();
                }
            });
        }
    }

    resetSession = () => {
        const { cookies } = this.props;

        cookies.set(cookie.token_timeout, false, { path: '/' });
    }

    validateLanguage = () => {
        const language = storage.getLanguage();
        if (language === null) {
            storage.saveLanguage("fr");
            i18n.changeLanguage("fr");
            this.setState({ language: "fr" });
        }
        else {
            i18n.changeLanguage(language);
            this.setState({ language: language });
        }
    }

    changeLogo = (language) => {
        this.state.language = language;
    }

    handleErrorLogin = (statusLogin) => {
        if (statusLogin === LoginCode.LOGIN_PASSWORDFIRSTSETUP) {
            this.setState({ openFirstSetup: true });
        }
    }

    handleLoginStep2 = (list) => {
        if (IsEmployeeMode()) {
            storage.saveCompanies(list);
        }

        if (IsSupervisorMode()) {
            storage.saveWorksites(list);
        }

        this.setState({
            openLoginStep2: true,
            listStep2: list
        })
    }

    handleCloseFirstSetup = () => {
        this.setState({ openFirstSetup: false });
    }

    handleCloseLoginStep2 = () => {
        this.setState({ openLoginStep2: false });
    }

    handleOnChangeLoginStep2 = async (value, accessType) => {
        const company = value.split('|')[0];

        const worksite = value.split('|')[1];

        await generateToken(company, worksite, accessType);

        this.connect();
    }

    handleCloseLoginChangePassword = (success) => {
        this.setState({ openLoginChangePassword: false });

        if (success === true) {
            this.alert.current.showMessageSuccess(i18next.t('password:success.message.password-saved'));
        }
    }

    handleOpenLoginChangePassword = (userCode) => {
        this.setState({ openLoginChangePassword: true, userCode: userCode });
    }

    handleChangeLanguage = (language) => {
        this.setState({ language: language });
    }

    handleChangeUserCode = (userCode) => {
        this.setState({ userCode: userCode });
    }

    connect = () => {
        connectApp(this.props);
    }

    handleShowForgotPassword = (show) => {
        this.setState({ showForgotPassword: show });
    }

    handleShowForgotUserName = (show) => {
        this.setState({ showForgotUserName: show });
    }

    handleMultiCompany = (isMultiCompany) => {
        this.setState({ isMultiCompany: isMultiCompany });
    }

    handleDefaultCompany = (defaultCompany) => {
        this.setState({ defaultCompany: defaultCompany });
    }

    handleIsActivatePrefix = (isActivatePrefix) => {
        this.setState({ isActivatePrefix: isActivatePrefix });
    }

    saveListPrefixConnection = (list) => {
        this.setState({ listPrefixConnection: list });
    }

    render() {
        return (
            <div>
                <div className={`${styles.logo} ${styles.logoAnimation} ${this.state.applyAnimation && styles.logoAnimationFinal}`}>
                    <img src={logo} alt="KoneK Mobile" />
                </div>

                <div className={styles.login_form}>
                    <section className={styles.loginWrapper}>
                        <div className={`${styles.logo}`}>
                            <img src={logo} alt="KoneK Mobile" />
                            {this.state.companyTitle !== '' &&
                                <span className={`${styles.logoSpan}`}>{this.state.companyTitle}</span>
                            }
                        </div>
                        {!this.state.errorLogin && this.state.errorGeneral && <Alert variant="danger">
                            {i18next.t('login:login.validation.error-login')}
                        </Alert>
                        }
                        {!this.state.errorLogin && this.state.errorSSO && <Alert variant="danger">
                            {i18next.t('login:login.validation.error-login-sso')}
                        </Alert>
                        }
                        {!this.state.errorLogin && this.state.errorMenu && <Alert variant="danger">
                            {i18next.t('login:login.validation.not-found-menu')}
                        </Alert>
                        }
                        {!this.state.errorLogin && this.state.errorParam && <Alert variant="danger">
                            {i18next.t('login:login.validation.no-param')}
                        </Alert>
                        }
                        {this.state.errorLogin && <Alert variant="danger">
                            {i18next.t('login:login.validation.error-login')}
                        </Alert>
                        }
                        <LoginForm handleErrorLogin={this.handleErrorLogin}
                            handleLoginStep2={this.handleLoginStep2}
                            handleChangePassword={this.handleOpenLoginChangePassword}
                            changeParentLogo={this.changeLogo}
                            handleChangeLanguage={this.handleChangeLanguage}
                            connect={this.connect}
                            handleChangeUserCode={this.handleChangeUserCode}
                            handleShowForgotPassword={this.handleShowForgotPassword}
                            handleShowForgotUserName={this.handleShowForgotUserName}
                            saveListPrefixConnection={this.saveListPrefixConnection}
                            handleMultiCompany={this.handleMultiCompany}
                            handleIsActivatePrefix={this.handleIsActivatePrefix}
                            handleDefaultCompany={this.handleDefaultCompany}
                        />
                        <FirstSetup openFirstSetup={this.state.openFirstSetup} handleClose={this.handleCloseFirstSetup} language={this.state.language} userCode={this.state.userCode} listPrefixConnection={this.state.listPrefixConnection} />
                        <LoginStep2 openLoginStep2={this.state.openLoginStep2} handleClose={this.handleCloseLoginStep2} list={this.state.listStep2} onChange={this.handleOnChangeLoginStep2} />
                        <LoginChangePassword openLoginChangePassword={this.state.openLoginChangePassword} handleClose={this.handleCloseLoginChangePassword} userCode={this.state.userCode} listPrefixConnection={this.state.listPrefixConnection} />

                        <div className={styles.loginLink}>
                            {this.state.showForgotUserName &&
                                <ForgotUserName listPrefixConnection={this.state.listPrefixConnection} isMultiCompany={this.state.isMultiCompany} defaultCompany={this.state.defaultCompany} isActivatePrefix={this.state.isActivatePrefix} />
                            }
                            {(this.state.showForgotUserName && this.state.showForgotPassword) &&
                                <div className={styles.linkSeparator}>
                                    |
                                </div>
                            }
                            {this.state.showForgotPassword &&
                                <ForgotPassword listPrefixConnection={this.state.listPrefixConnection} />
                            }
                        </div>
                        <InstallPWA />
                        <InstallPWAIOS />
                    </section>

                </div>
                <HelpOnlineButton SourcePage={SourcePage.Source_Login} />
                <div id="divVersion" className={`${styles.divVersion} ${this.state.isiOS && styles.divVersionIOS}`}>
                    {this.state.version}{this.state.buildNumber > 0 ? ` (${this.state.buildNumber})` : ""}
                </div>
                <AlertAlgo ref={this.alert} />
            </div>
        );
    }
}

export default withNamespaces(['login', 'password'], { wait: true })(withCookies(Login));